<div class="">
  <div>
    <!-- <h5 class="title-head">Change Password</h5> -->
    <div class="modal-header">
      <h5 class=" modal-title">Change Password</h5>
    </div>
  </div>
  <form [formGroup]="passwordForm" autocomplete="off">
    <div class="row modal-body">
      <!-- User Name -->
      <div class="col-md-6 py-3">
        <label class="form-label required">User name</label>
        <input
          type="text"
          class="form-control"
          formControlName="username"
          readonly
        />
      </div>
      <!-- Old Password -->
      <div class="col-md-6 py-3">
        <label class="form-label required">Old Password</label>
        <div class="input-group">
          <input
            type="text"
            placeholder="Old Password"
            class="form-control"
            formControlName="oldpassword"
            [type]="oldPasswordFieldType"
            [ngClass]="{
              'is-invalid': isInvalid('oldpassword')
            }"
          />
          <button
            class="input-group-text"
            (click)="togglePasswordVisibility('oldpassword')"
            type="button"
          >
            <i
              [class]="
                oldPasswordFieldType == 'password'
                  ? 'fa fa-eye-slash'
                  : 'fa fa-eye'
              "
            ></i>
          </button>
          <div
            *ngIf="isInvalid('oldpassword')"
            class="invalid-feedback"
          >
            <span *ngIf="form['oldpassword'].errors?.['required']"
              >Old Password is required</span
            >
            <span *ngIf="form['oldpassword'].errors?.['pattern']"
              >Enter valid Oldpassword.</span
            >
          </div>
        </div>
      </div>
      <!-- New password -->
      <div class="col-md-6 form-group pb-3">
        <label for="newpassword" class="form-label required"
          >New Password</label
        >
        <div class="input-group">
          <input
            id="newpassword"
            class="form-control"
            [type]="passwordFieldType"
            placeholder="New Password"
            formControlName="newpassword"
            (copy)="onCopy($event)"
            (paste)="onPaste($event)"
            [ngClass]="{
              'is-invalid': isInvalid('newpassword')
            }"
          />
          <button
            class="input-group-text"
            (click)="togglePasswordVisibility('newpassword')"
            type="button"
          >
            <i
              [class]="
                passwordFieldType == 'password'
                  ? 'fa fa-eye-slash'
                  : 'fa fa-eye'
              "
            ></i>
          </button>
          <div
            *ngIf="isInvalid('newpassword')"
            class="invalid-feedback"
          >
            <p
              class="err_msg_p"
              *ngIf="form['newpassword'].errors?.['required']"
            >
              New Password is required
            </p>
            <p
              class="err_msg_p"
              *ngIf="form['newpassword'].errors?.['minlength']"
            >
              Minimum length
              {{ passLength }}
              characters.
            </p>
            <p
              class="err_msg_p"
              *ngIf="form['newpassword'].errors?.['maxlength']"
            >
              Maximum length 14 characters.
            </p>
            <p
              class="err_msg_p"
              *ngIf="form['newpassword'].errors?.['pattern']"
            >
              {{ passwordHint }}
            </p>
          </div>
          <p class="err_msg_p error-message mt-1" *ngIf="showMessage">
            Copy and Paste are not allowed for security reasons!
          </p>
        </div>
      </div>
      <!-- Confirm Password -->
      <div class="col-md-6 form-group">
        <label for="confirmpassword" class="form-label required"
          >Confirm Password</label
        >
        <div class="input-group">
          <input
            id="confirmpassword"
            class="form-control"
            [type]="confirmPasswordFieldType"
            placeholder="Confirm Password"
            (copy)="onCopy($event)"
            (paste)="onPaste($event)"
            formControlName="confirmpassword"
            [ngClass]="{
              'is-invalid': isInvalid('confirmpassword')
            }"
          />

          <button
            class="input-group-text"
            (click)="togglePasswordVisibility('confirmpassword')"
            type="button"
          >
            <i
              [class]="
                confirmPasswordFieldType == 'password'
                  ? 'fa fa-eye-slash'
                  : 'fa fa-eye'
              "
            ></i>
          </button>
          <div
            *ngIf="isInvalid('confirmpassword')"
            class="invalid-feedback"
          >
            <span *ngIf="form['confirmpassword'].errors?.['required']"
              >Confirm Password is required</span
            >
            <span *ngIf="form['confirmpassword'].errors?.['pattern']"
              >Enter Valid confirm password.</span
            >
            <span *ngIf="form['confirmpassword'].errors?.['mismatch']"
              >Password not match</span
            >
          </div>
          <p class="err_msg_p error-message mt-1" *ngIf="showMessage">
            Copy and Paste are not allowed for security reasons!
          </p>
        </div>
      </div>
      <div class="">
        <button class="btn btn-sm submit" (click)="formSubmit()" type="button">
          Update
        </button>
        <button
          class="btn btn-sm cancel"
          (click)="goToBack()"
          routerLinkActive="router-link-active"
          type="button"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>
</div>
